<template>
    <v-dialog max-width="600px" v-model="dialog">
        <!-- <v-btn flat slot="activator" color="primary">Add a quote or Excerpt</v-btn> -->
        <v-btn slot="activator" class="mx-2" flat fab>
        <v-icon dark>add</v-icon>
        </v-btn>
        <v-card>
            <v-card-title>
                <span class="headline font-weight-bold">Add a user story:</span> 
                <!-- <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify"
                outline>
                You have seleect
              </v-alert>  -->
            </v-card-title>

            <v-card-text>
                <v-form class="px-3" ref="form">
                    <v-textarea outline :label="userroleLabelText" v-model="userrole" :hint="userroleHint" :rules="textInputRules"></v-textarea>
                    <v-textarea outline :label="desiredactionLabelText" v-model="desiredaction" :hint="desiredactionHint" :rules="textInputRules"></v-textarea>
                    <v-textarea outline :label="usergoalLabelText" v-model="usergoal" :hint="usergoalHint" :rules="textInputRules"></v-textarea>
                    <!-- <v-checkbox v-model="firstprefquotemetricsuggestionsuitability" label="One or more metric(s) can be added based on this quote"></v-checkbox> -->
                    <!-- <v-radio-group v-model="row" row>
                        <v-radio label="Option 1" value="radio-1"></v-radio>
                        <v-radio label="Option 2" value="radio-2"></v-radio>
                        </v-radio-group> -->
                                        <!-- <v-btn flat color="primary" @click="submit" :loading="loading">Add Story</v-btn>  -->
                    <v-btn flat color="primary" @click="dummySubmit" :loading="loading">Add Story</v-btn> 
                    <!-- <v-btn flat to="/bifdashboard" color="primary" class="mx-2 mt-3" :loading="loading">Add Story</v-btn> -->
                    <v-btn flat @click="dialog = false">Cancel</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
    name: '',
    data() {
        return{
            userrole: 'casual user',
            desiredaction: 'to add a task in the least amount of steps possible',
            usergoal: 'I can collect all tasks to be managed in a single location',
            userroleLabelText: 'As a:',
            desiredactionLabelText: 'I want: ',
            usergoalLabelText: 'so that: ',
            userroleHint: 'Who is the user for this story?',
            desiredactionHint: 'What is the desired action, which the user is able to performe using the system?',
            usergoalHint: 'What is the goal of the user when performing this action?',
            //items: ['Pain Point', 'User Story', 'Both Enterprise and Consumer', 'Not Sure'],
            textInputRules: [
                    v => !!v || 'This field is required',
                    v => v.length >= 3 || 'Minimum length is 3 characters'
                ],
            loading: false,
            dialog: false
        }
    },
    methods: {
        submit() {

             if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            //details = {}

            const userstory = {
                userrole: this.userrole,
                desiredaction: this.desiredaction,
                usergoal: this.usergoal
            }

            //details['prefs'] = firstprefdetails;
 

            //
            //xuWrU7qOYXxLjL97QoCe

        var dbref = db.collection('projects').doc(this.getProjectID()).collection('userstories');

        dbref.add(userstory).then(() =>{
            //console.log('Collection quotes created')
                      this.loading = false;
          this.dialog = false;
          this.$emit('storyconfirmed')
        });


    //     db.collection('projects').doc('Yx3r6dHUeFFdGvY6Acvy').collection('quotesregardingfirstprefsolutionconcept').update(quote).then(() => {
    //       //console.log("added to db!", docRef.id)
    //       this.loading = false;
    //       this.dialog = false;
    //       this.$emit('quoteconfirmed')
    //    });

             }
        },
        dummySubmit(){
            this.loading = false;
          this.dialog = false;

        },
    getProjectID(){
      return gvars.PROJECTID;
    } 
    }
}
</script>
